export default __webpack_public_path__ + "static/media/twitter.3329ea3b.svg";